import BaseService from './base.service';

export default class OrgPropertyVisitorService {
    static ENDPOINT = '/orgs';

    static async addOrgVisitor(orgId, propertyId, visitorData) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/visitors`;
        return BaseService.post(endpoint, visitorData);
    }

    static async updateOrgVisitor(orgId, propertyId, visitorId, visitorData) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/visitors/${visitorId}`;
        return BaseService.patch(endpoint, visitorData);
    }

    static async removeOrgVisitor(orgId, propertyId, visitorId) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/visitors/${visitorId}/remove`;
        return BaseService.patch(endpoint, null);
    }

    static async suspendOrgVisitor(orgId, propertyId, visitorId, suspended) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/visitors/${visitorId}/suspend`;
        return BaseService.patch(endpoint, { suspended: suspended });
    }

    static async removeOccupantsVisitor(orgId, propertyId, visitorId) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/visitors/${visitorId}/occupant/remove`;
        return BaseService.patch(endpoint, null);
    }

    static async suspendOccupantsVisitor(orgId, propertyId, visitorId, suspended) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/visitors/${visitorId}/occupant/suspend`;
        return BaseService.patch(endpoint, { suspended: suspended });
    }
}
